export interface HsrpWidgetLandingProps {
  widget: string
  widgetHeading?: string
  regexPatternsData?: object
  widgetCtaText?: string
  inputPlaceholder?: string
  isMobileDevice: boolean
  hsrpFinalScreenData: object
  widgetOptions: any
  segmentEventCommonProperties?: object
  isBottomFloater: boolean
  onHide: Function
}

export type HsrpUserData = {
  mobile_number: string
  reg_number: string
  vehicleInfo?: Record<string, any> | null
  logo_url?: string
}

export const initUserData: HsrpUserData = {
  mobile_number: '',
  reg_number: '',
  vehicleInfo: null,
  logo_url: '',
}
